import script from "./AppTopbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTopbar.vue?vue&type=script&setup=true&lang=ts"

import "./AppTopbar.vue?vue&type=style&index=0&id=34925410&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34925410"]])

export default __exports__